// extracted by mini-css-extract-plugin
export default {"tooltip":"NX-z","arrow":"OX-z"};